export default "__VITE_ASSET__DH7Q0ahk__"